import React, { useEffect, useState } from "react";

import { Col, DatePicker, Form, Radio, Row, Spin } from "antd";

import moment from "moment/moment";

import userTrendApi from "../../../../apis/UserTrend.api";

import GoogleAnalytics from "./GoogleAnalytics";

const UserDashboard = () => {
  const [isLoading, setIsLoading] = useState(true);

  const [dateType, setDateType] = useState("today");
  const dateTypeItems = [
    { label: "오늘", value: "today" },
    { label: "1주일", value: "1week" },
    { label: "1개월", value: "1month" },
    { label: "3개월", value: "3month" },
    // {label: "6개월", value: "6month"}
  ];
  const [searchOptions, setSearchOptions] = useState({
    startDate: moment().startOf("day"),
    endDate: moment().endOf("day"),
  });

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    switch (value) {
      case "today":
        setSearchOptions({
          ...searchOptions,
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day"),
        });
        break;
      case "1week":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(7, "days")
              .startOf("day"),
          });
        }
        break;
      case "1month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "months")
              .startOf("day"),
          });
        }
        break;
      case "3month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(3, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(3, "months")
              .startOf("day"),
          });
        }
        break;
      case "6month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(6, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(6, "months")
              .startOf("day"),
          });
        }
        break;
    }
  };

  const [data, setData] = useState({});

  useEffect(() => {
    if (searchOptions?.startDate && searchOptions?.endDate) {
      getTrend();
    }
  }, [searchOptions]);

  /**
   * 유저 현황 가져오기
   * @returns {Promise<void>}
   */
  const getTrend = async () => {
    setIsLoading(true);
    let param = {
      startDate: searchOptions.startDate.format("YYYY-MM-DD"),
      endDate: searchOptions.endDate.format("YYYY-MM-DD"),
    };
    const trendRes = await userTrendApi.userTrend(
      param.startDate,
      param.endDate,
    );
    if (trendRes.code === 200) {
      setData({
        newUserCnt: trendRes.result?.newUserCnt ?? 0,
        dailyUserCnt: trendRes.result?.dailyUserCnt ?? 0,
        totalUserCnt: trendRes.result?.totalUserCnt ?? 0,
      });
    }
    setIsLoading(false);
  };

  return (
    <Row className="order-component-box main-component-box">
      {isLoading && <Spin style={{ zIndex: 1 }} />}
      <div className={`order-component-title-div main-component-title-div`}>
        <h2 className="order-component-title">가입/유입 통계</h2>
        <GoogleAnalytics />
      </div>
      <div
        className={`order-component-info`}
        style={{
          gap: "1.5rem",
        }}
      >
        <Row
          className={`order-component-each`}
          align={"middle"}
          id={`statistics-date`}
          style={{ gap: "4px" }}
        >
          <Form.Item
            style={{
              margin: 0,
              padding: 0,
            }}
          >
            <Radio.Group
              options={dateTypeItems}
              onChange={handleDateTypeChange}
              value={dateType}
              optionType="button"
              className={`options-list`}
              style={{
                padding: 0,
              }}
            />
            <Row
              align={"middle"}
              style={{
                gap: "3px",
              }}
            >
              <DatePicker
                className="main-statistics-date"
                format="YYYY/MM/DD"
                value={searchOptions.startDate}
                allowClear={false}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, startDate: value });
                }}
              />
              <span className={`gray-font`}>~</span>
              <DatePicker
                className="main-statistics-date"
                format="YYYY/MM/DD"
                value={searchOptions.endDate}
                allowClear={false}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, endDate: value });
                }}
              />
            </Row>
          </Form.Item>
        </Row>
        <Row
          className={`order-component-each`}
          align={"middle"}
          id={`statistics-date`}
          style={{ gap: "4px", display: "none" }}
        >
          <Form.Item
            style={{
              margin: 0,
              padding: 0,
            }}
          >
            <Radio.Group
              options={dateTypeItems}
              onChange={handleDateTypeChange}
              value={dateType}
              optionType="button"
              className={`options-list`}
              style={{
                padding: 0,
              }}
            />
            <Row
              align={"middle"}
              style={{
                gap: "3px",
              }}
            >
              <DatePicker
                className="main-statistics-date"
                format="YYYY/MM/DD"
                value={searchOptions.startDate}
                allowClear={false}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, startDate: value });
                }}
              />
              <span className={`gray-font`}>~</span>
              <DatePicker
                className="main-statistics-date"
                format="YYYY/MM/DD"
                value={searchOptions.endDate}
                allowClear={false}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, endDate: value });
                }}
              />
            </Row>
          </Form.Item>
        </Row>
        <Row className={`order-component-each`} align={"middle"}>
          <div className={`order-component-each-detail`}>
            <h4
              className={`order-each-detail-title`}
              style={{ display: "none" }}
            >
              {moment(searchOptions.startDate).format("YYYY.MM.DD")} ~{" "}
              {moment(searchOptions.endDate).format("YYYY.MM.DD")}
            </h4>
            <Col className={`main-component-col`}>
              {/* 방문자수 */}
              <Row
                className="order-component-box main-component-sell"
                style={{
                  gap: "8px",
                  rowGap: "8px",
                  padding: "1.5rem 0",
                  flex: 1,
                }}
              >
                <h4 className={`order-each-detail-title`}>방문자수</h4>
                <p className={`big-font`} style={{ color: "#117FFA" }}>
                  {data?.dailyUserCnt ? data?.dailyUserCnt.toLocaleString() : 0}
                  명
                </p>
              </Row>

              {/* 신규회원수 */}
              <Row
                className="order-component-box main-component-sell"
                style={{
                  gap: "8px",
                  rowGap: "8px",
                  padding: "1.5rem 0",
                  flex: 1,
                }}
              >
                <h4 className={`order-each-detail-title`}>신규회원수</h4>
                <p className={`big-font`} style={{ color: "#1ca717" }}>
                  {data?.newUserCnt ? data?.newUserCnt.toLocaleString() : 0}명
                </p>
              </Row>

              {/* 기존회원수 */}
              <Row
                className="order-component-box main-component-sell"
                style={{
                  gap: "8px",
                  rowGap: "8px",
                  padding: "1.5rem 0",
                  flex: 1,
                }}
              >
                <h4 className={`order-each-detail-title`}>기존회원수</h4>
                <p className={`big-font`} style={{ color: "#bbc71d" }}>
                  {data?.totalUserCnt
                    ? (
                        data?.totalUserCnt -
                        (data?.newUserCnt ? data?.newUserCnt : 0)
                      )?.toLocaleString()
                    : 0}
                  명
                </p>
              </Row>
            </Col>
          </div>
        </Row>
      </div>
    </Row>
  );
};
export default UserDashboard;
